// The words of an answer as the avatar says them (profile_stage_controller):
// when each one starts, and the chat bubble that shows them lit up in blue,
// one word at a time, karaoke-style.
//
// Without real timings (`times`, seconds from the start) each word gets a
// share of the length by its letters, and a pause after punctuation - close
// enough to follow along, and it runs off the audio's own clock, so it never
// drifts from the sound.

const PAUSE = { ",": 2, ";": 3, ":": 3, ".": 5, "!": 5, "?": 5 }

export function splitWords(text) {
  return String(text || "").trim().split(/\s+/).filter(Boolean)
}

export function wordTimes(words, duration) {
  const weights = words.map((word) => word.replace(/[^\p{L}\p{N}]/gu, "").length + 2 + (PAUSE[word.slice(-1)] || 0))
  const total = weights.reduce((sum, w) => sum + w, 0) || 1
  let at = 0
  return weights.map((weight) => {
    const start = at
    at += (weight / total) * duration
    return start
  })
}

// The index of the word being said at `seconds`.
export function wordAt(times, seconds) {
  let index = 0
  while (index + 1 < times.length && times[index + 1] <= seconds) index += 1
  return index
}

const normalize = (text) => String(text || "").replace(/\s+/g, " ").trim()

// The newest chat bubble holding exactly this answer (the Ask list's own
// exchange, or a twin chat's saved answer), its words wrapped once.
export class SpokenBubble {
  constructor(text) {
    this.text = normalize(text)
    this.words = []
  }

  find() {
    if (this.words.length && this.bubble?.isConnected) return true
    const bubbles = [...document.querySelectorAll(".assistant-bubble-assistant")].reverse()
    const bubble = bubbles.find((el) => normalize(el.textContent) === this.text)
    if (!bubble) return false
    this.bubble = bubble
    if (bubble.dataset.spokenWrapped) {
      this.words = [...bubble.querySelectorAll(".spoken-word")]
      return true
    }
    // A bubble with formatting inside (a rendered reply) is left as it is.
    if (bubble.children.length) return false
    bubble.replaceChildren(...bubble.textContent.trim().split(/(\s+)/).map((part) => {
      if (/^\s+$/.test(part)) return document.createTextNode(part)
      const span = document.createElement("span")
      span.className = "spoken-word"
      span.textContent = part
      return span
    }))
    bubble.dataset.spokenWrapped = "1"
    this.words = [...bubble.querySelectorAll(".spoken-word")]
    return true
  }

  show(index) {
    if (!this.find()) return
    this.words.forEach((word, i) => {
      word.classList.toggle("is-spoken", i === index)
      word.classList.toggle("was-spoken", i < index)
    })
  }

  clear() {
    this.words.forEach((word) => word.classList.remove("is-spoken", "was-spoken"))
  }
}
